import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { EOtpremniceClient, IAdresaIsporukeDto, TipOtpremnice } from '@kodit/core/data-api';
import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';
import { AutoComplete } from 'primeng/autocomplete';
import { Subscription } from 'rxjs';
import { EotpremnicaFormService } from '../../otpremnice/eotpremnica-form.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';

export interface IRequest {
  searchValue: string;
}

@Component({
  selector: 'kodit-adresa-magacin-autocomplete',
  templateUrl: './adresa-magacin-autocomplete.component.html',
  styleUrls: ['./adresa-magacin-autocomplete.component.scss'],
})
export class AdresaMagacinAutocompleteComponent implements OnInit, OnDestroy {
  /** Subs */
  private _searchSub: Subscription = new Subscription();

  /** Props */
  formGroup: FormGroupTypeSafe<IRequest>;
  adreseSuggestions: IAdresaIsporukeDto[] = [];

  @ViewChild('autocompleteRef') autocompleteRef: AutoComplete;

  /** I/O */
  @Input() parentCtrl: any = 'body';
  @Input() mustSelect: boolean = false;
  @Input() ctrlDisabled: boolean = false;
  @Input() jeInterna: boolean = false;
  @Input() jeAdresaOtpreme: boolean = false;
  @Input() jeAdresaOdredista: boolean = false;
  @Input() ctrlPlaceholder: string = 'Unesite naziv magacina';
  @Input() isInvalid: boolean = false;
  @Output () onNazivChange = new EventEmitter<string>();
  @Output() onAdresaChange = new EventEmitter<IAdresaIsporukeDto>();
  @Output() onAdresaClear = new EventEmitter<void>();


  constructor(
    private _fb: FormBuilderTypeSafe,
    private _client: EOtpremniceClient,
    private _otpremniceService: EotpremnicaFormService,
    private _route: ActivatedRoute
  ) {}

  ngOnInit(): void {

    this.formGroup = this._fb.group<IRequest>({
      searchValue: new FormControl(''),
    });

    if(this._otpremniceService.jePretovarEditSubject.value)
    {
      this.formGroup.disable();
    }

    this.jeInterna =
      this._otpremniceService.getOtpremnicaFormObject?.controls.tipOtpremnice
        .value === TipOtpremnice.INTERNA;
  }

  searchMagacin(event: any) {
    if (this.formGroup.value.searchValue.length < 1) {
      this.adreseSuggestions = [];
      return;
    }
    this._searchSub.unsubscribe();
    this._searchSub = this._client
      .searchMagacinAdreseIsporuke(this.formGroup.value.searchValue)
      .subscribe((result) => {
        this.adreseSuggestions = result.data;
      });
  }

  selectionChanged(value: IAdresaIsporukeDto) {
    if (this.onAdresaChange) {
      this.onAdresaChange.emit(value);
      //this.formGroup.controls.searchValue.reset('');
      //this._racunService.setShowFizickoLiceCreate = null;
    }
  }

  nazivChanged(event: any) {
    if (this.onNazivChange && event.target?.value) {
      this.onNazivChange.emit(event.target.value);
    }
  }

  onClear() {
    this.formGroup.reset();
    if (this.onAdresaClear) {
      this.onAdresaClear.emit();
    }
  }

  ngOnDestroy(): void {
    this._searchSub.unsubscribe();
  }
}
